import React, { useMemo, useState } from "react";
import Plot from "react-plotly.js";

import LiveMarketOverview from "../marketsnap";
import MarketBreadth from "./market_breadth";
import SectorPerformance from "./sector_performance";
import IndexPerformanceChart from "./IndexPerformanceChart";
import AnalyticsCard from "../home/AnalyticsCard";
import MetricAssistant from "../common/MetricAssistant";


export default function MarketSummary({
    activeWidget,
    indices
    }) {

    const historicalData = useMemo(() => {

        try {

            return JSON.parse(
                indices.hist_df
            );

        } catch {

            return [];

        }

    }, [indices]);

    switch (activeWidget) {

        case "Major Indices":

            return (

                <div>

                    {/*<LiveMarketOverview />*/}
                    <div className="mb-10">
                        <MetricAssistant
                            title="Market Guide"
                            context="market"
                        />
                        <AnalyticsCard title="Global Markets">

                            {/*<IndexPerformanceChart*/}
                            {/*    indices={*/}
                            {/*        historicalData*/}
                            {/*    }*/}
                            {/*/>*/}
                            <IndexPerformanceChart
                                indices={historicalData}
                                title="Global Indices"
                                defaultTickers={[
                                    "NIFTY 50",
                                    "S&P500"
                                ]}
                            />
                        </AnalyticsCard>

                    </div>



                </div>

            );

        case "Market Breadth":

            return <MarketBreadth />;

        case "Sector Performance":

            return <SectorPerformance />;

        default:

            return (

                <div
                    className="
                        bg-white
                        rounded-3xl
                        p-10
                        border
                    "
                >
                    Select a section
                </div>

            );
    }
}
